export default "__VITE_ASSET__EAfHbzkI__"